import { MenuItem } from "@mui/material";
import ThreeDotsMenu from "components/ThreeDots/ThreeDotsMenu";
import { FormattedMessage as T } from "react-intl";

type EmailActionsProps = {
  onView: () => void;
  onResend: () => void;
};

export default function EmailActions({
  onView,
  onResend,
}: Readonly<EmailActionsProps>) {
  return (
    <ThreeDotsMenu>
      <MenuItem onClick={onView}>
        <T id="viewEmail" />
      </MenuItem>
      <MenuItem onClick={onResend}>
        <T id="resendEmail" />
      </MenuItem>
    </ThreeDotsMenu>
  );
}
